export default __webpack_public_path__ + "static/media/pdf_1.fc171422.svg";